import { useLocation } from 'react-router-dom';
import { getAppContextFromPath } from 'src/router/pathUtils';
import { ALL_SELECTION_ID } from 'src/utils/selection';

import { useSelectedApplicationId } from './useSelectedApplicationId';

const useEffectiveApplicationId = () => {
  const location = useLocation();
  const { appId: appIdFromPath } = getAppContextFromPath(location.pathname);
  const { selectedApplicationId } = useSelectedApplicationId();

  return appIdFromPath ?? selectedApplicationId ?? ALL_SELECTION_ID;
};

export default useEffectiveApplicationId;
